import { Link } from 'react-router-dom';
import { can, type Me } from '../auth/me';

/**
 * Small "Zarządzaj zestawami" link next to a kit picker of a packlist or a template (rule 9 of docs/wyglad.md). Kits
 * live in "Szablony" → "Zestawy" (owner 20.10 23:37); the quote has no such link (owner: "nie potrzebne tutaj").
 */
export function ManageKitsLink({ me }: { me: Me }) {
  if (!can(me, 'kits.kits', 'view')) return null;
  return (
    <Link className="manage-link" to="/szablony/zestawy" title="Zestawy znajdziesz w Szablony → Zestawy (także Katalog sprzętu → ⚙ → Zestawy…)">
      Zarządzaj zestawami
    </Link>
  );
}
